/* KitKraft — product page: sticky add-to-cart reveal, empty-review cleanup,
   auto/personalised related products (deduped against "Frequently bought
   together"). */
(function () {
  "use strict";

  function initSticky() {
    var bar = document.querySelector("[data-kk-satc]");
    if (!bar) return;
    var form = document.querySelector(".js-form-add-to-cart");
    var realBtn = form && form.querySelector('button[name="add"], .js-atc-btn');
    if (!form || !realBtn) return;

    var proxyBtn = bar.querySelector("[data-kk-satc-add]");
    var priceOut = bar.querySelector("[data-kk-satc-price]");
    var livePrice = document.querySelector(".js-price");
    var livePriceWrap = document.querySelector(".product-details_price-wrapper") || document.querySelector(".porduct-details");

    function syncPrice() {
      if (!priceOut) return;
      var now = document.querySelector(".js-price");
      var cmp = document.querySelector(".js-price-compare");
      var html = "";
      if (cmp && !cmp.classList.contains("d-none") && cmp.textContent.trim()) {
        html += "<del>" + cmp.textContent.trim() + "</del>";
      }
      if (now) html += now.textContent.trim();
      if (html) priceOut.innerHTML = html;
    }
    syncPrice();
    if (livePriceWrap && window.MutationObserver) {
      new MutationObserver(syncPrice).observe(livePriceWrap, { subtree: true, childList: true, characterData: true });
    }

    // mirror sold-out / disabled state
    function syncState() {
      var disabled = realBtn.disabled;
      proxyBtn.disabled = disabled;
      proxyBtn.textContent = disabled ? "Sold out" : "Add to cart";
    }
    syncState();
    if (window.MutationObserver) {
      new MutationObserver(syncState).observe(realBtn, { attributes: true, attributeFilter: ["disabled"] });
    }

    proxyBtn.addEventListener("click", function () {
      if (realBtn.disabled) return;
      realBtn.click();
    });

    // show the bar once the real Add button has scrolled above the viewport
    var shown = false;
    function setShown(on) {
      if (on === shown) return;
      shown = on;
      bar.classList.toggle("is-on", on);
      bar.setAttribute("aria-hidden", on ? "false" : "true");
      document.body.classList.toggle("kk-satc-on", on);   // lets CSS lift the WhatsApp bubble clear of the bar
    }
    var siteFoot = document.querySelector(".footer, footer.site-footer, #shopify-section-footer, [class*='footer-bottom']");
    function update() {
      var r = realBtn.getBoundingClientRect();
      // sold-out (button disabled or hidden): a permanent disabled "Sold out" bar adds nothing
      if (realBtn.disabled || (r.width === 0 && r.height === 0)) { setShown(false); return; }
      var past = r.bottom < 8;
      // phones: the buy button is ~2 screens down, so show the bar from first paint whenever the
      // real button isn't on screen (above OR below), not only after it has scrolled away.
      if (!past && window.innerWidth <= 767 && r.width > 0 && r.top > window.innerHeight - 8) past = true;
      // don't cover the real site footer once it's well into view
      var atFoot = false;
      if (siteFoot) { var fr = siteFoot.getBoundingClientRect(); atFoot = fr.top < window.innerHeight * 0.6; }
      setShown(past && !atFoot);
    }
    update();
    var tick = 0;
    function onScroll() {
      if (tick) return;
      tick = setTimeout(function () { tick = 0; update(); }, 60);
    }
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll, { passive: true });
  }

  function tidyReviews() {
    var wrap = document.querySelector(".product-info_reviews");
    if (!wrap) return;
    function check() {
      var badge = wrap.querySelector(".jdgm-prev-badge");
      var txt = (wrap.textContent || "").trim().toLowerCase();
      var zero = (badge && badge.getAttribute("data-number-of-reviews") === "0") ||
        txt === "" || txt === "no reviews" || txt.indexOf("no reviews") === 0;
      wrap.classList.toggle("kk-noreviews", !!zero);
    }
    check();
    if (window.MutationObserver) {
      new MutationObserver(check).observe(wrap, { subtree: true, childList: true, characterData: true, attributes: true });
      setTimeout(function () { check(); }, 2500);
    }
  }

  /* ---- collapse the big Judge.me widget when there are no reviews yet ---- */
  function tidyBigReviews() {
    var w = document.getElementById("judgeme_product_reviews");
    if (!w) return;
    function check() {
      var hasReviews = w.querySelectorAll(".jm-review, .jdgm-rev").length > 0;
      var emptyMarker = !!w.querySelector(".jm-no-reviews-state, .jdgm-empty-state");
      var empty = !hasReviews && (emptyMarker || /be the first/i.test(w.textContent || ""));
      w.classList.toggle("kk-rev-empty", empty);
    }
    check();
    if (window.MutationObserver) {
      new MutationObserver(check).observe(w, { subtree: true, childList: true });
      setTimeout(check, 2500);
      setTimeout(check, 6000);
    }
  }

  /* ---- related products: replace the collection-based strip with Shopify's
     personalised recommendations, minus whatever "Frequently bought together"
     already shows. Falls back silently to the server-rendered strip. ---- */
  function initRelatedReco() {
    var wrap = document.querySelector(".secion-related-products[data-kk-related]");
    if (!wrap) return;
    var pid = wrap.getAttribute("data-product-id");
    var sid = wrap.getAttribute("data-section-id");
    var limit = parseInt(wrap.getAttribute("data-limit"), 10) || 10;
    if (!pid || !sid) return;

    function usedHandles() {
      var s = (window.KKCB && window.KKCB.usedHandles) || [];
      return Array.isArray(s) ? s : [];
    }

    function run() {
      var url = "/recommendations/products?section_id=" + encodeURIComponent(sid) +
        "&product_id=" + encodeURIComponent(pid) + "&intent=related&limit=" + (limit + 8);
      fetch(url, { headers: { "Accept": "text/html" } })
        .then(function (r) { return r.ok ? r.text() : ""; })
        .then(function (html) {
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, "text/html");
          var freshList = doc.querySelector(".slider-list");
          var curList = wrap.querySelector(".slider-list");
          if (!freshList || !curList) return;

          var used = usedHandles();
          var kept = 0;
          Array.prototype.forEach.call(freshList.querySelectorAll(".slider-item"), function (item) {
            var a = item.querySelector('a[href*="/products/"]');
            var h = a ? a.getAttribute("href").split("/products/")[1].split(/[?#]/)[0] : "";
            if ((h && used.indexOf(h) > -1) || kept >= limit) { item.remove(); return; }
            kept++;
          });

          if (kept < 2) return; // not enough to bother — keep the server strip
          curList.innerHTML = freshList.innerHTML;
          wrap.classList.remove("d-none");
          var sc = wrap.querySelector("slider-component");
          try { if (sc && typeof sc.init === "function") sc.init(); } catch (e) {}
        })
        .catch(function () {});
    }

    // wait for "Frequently bought together" to publish its handle list, but
    // don't block on it forever
    if (window.KKCB && window.KKCB.ready) { run(); return; }
    var done = false;
    var go = function () { if (done) return; done = true; run(); };
    document.addEventListener("kk:cb-ready", go, { once: true });
    setTimeout(go, 2600);
  }

  /* ---- turn the Description tab into an accordion, driven entirely by
     whichever heading tag actually repeats in that product's own copy
     (h2-h6). Content before the first repeating heading — usually a
     title + intro line — stays fixed above the collapsible sections.
     Products with no repeating heading are left exactly as they render
     today. No metafields, no per-kit config. ---- */
  function initDescAccordion() {
    var desc = document.getElementById("tab-content-description");
    if (!desc || desc.dataset.kkAccInit) return;
    desc.dataset.kkAccInit = "1";

    var HTAGS = ["H2", "H3", "H4", "H5", "H6"];
    var nodes = Array.prototype.slice.call(desc.childNodes);

    var counts = {};
    nodes.forEach(function (n) {
      if (n.nodeType === 1 && HTAGS.indexOf(n.tagName) > -1) {
        counts[n.tagName] = (counts[n.tagName] || 0) + 1;
      }
    });
    var boundaryTag = null;
    for (var i = 0; i < HTAGS.length; i++) {
      if (counts[HTAGS[i]] >= 2) { boundaryTag = HTAGS[i]; break; }
    }
    if (!boundaryTag) return;

    var lead = [];
    var sections = [];
    var started = false;
    nodes.forEach(function (n) {
      if (n.nodeType === 1 && n.tagName === boundaryTag) {
        started = true;
        sections.push({ heading: n, body: [] });
        return;
      }
      if (!started) { lead.push(n); return; }
      sections[sections.length - 1].body.push(n);
    });
    if (sections.length < 2) return; // not really an accordion-shaped description

    var frag = document.createDocumentFragment();
    lead.forEach(function (n) { frag.appendChild(n); });

    var acc = document.createElement("div");
    acc.className = "kk-desc-acc";
    sections.forEach(function (sec, idx) {
      var item = document.createElement("div");
      item.className = "kk-desc-acc__item" + (idx === 0 ? " is-open" : "");

      var btn = document.createElement("button");
      btn.type = "button";
      btn.className = "kk-desc-acc__h";
      btn.setAttribute("aria-expanded", idx === 0 ? "true" : "false");
      btn.innerHTML = sec.heading.innerHTML;

      var panel = document.createElement("div");
      panel.className = "kk-desc-acc__panel";
      panel.hidden = idx !== 0;
      sec.body.forEach(function (n) { panel.appendChild(n); });

      btn.addEventListener("click", function () {
        var open = item.classList.toggle("is-open");
        btn.setAttribute("aria-expanded", open ? "true" : "false");
        panel.hidden = !open;
      });

      item.appendChild(btn);
      item.appendChild(panel);
      acc.appendChild(item);
    });
    frag.appendChild(acc);

    desc.innerHTML = "";
    desc.appendChild(frag);
  }

  function boot() { initSticky(); tidyReviews(); tidyBigReviews(); initRelatedReco(); initDescAccordion(); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
